/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-dynamic-delete */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useContext, useEffect, useRef } from "react";
import { Loader } from "@progress/kendo-react-indicators";
import {
  Grid,
  GridColumn as Column,
  getSelectedState,
} from "@progress/kendo-react-grid";
import { process } from "@progress/kendo-data-query";
import { getter } from "@progress/kendo-react-common";
import {
  CirclePlus,
  CircleX,
  LucideFileDigit,
  SlidersHorizontal,
} from "lucide-react";
import { Link } from "react-router-dom";
import {
  Badge,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Button,
  Card,
  CardContent,
  CardDescription,
  Combobox,
  DatePicker,
  Input,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@repo/ui";
import { UserContext } from "utils/reducers/user";
import {
  isOperationAllowed,
  onSealFileUploadPayload,
  readOnlyExcelDate,
  showToast,
} from "utils/helper";
import Layout from "components/layout";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
import { ExcelRenderer } from "react-excel-renderer";
import {
  useGetCustomerCITList,
  useGetCustomers,
  useGetShiftRoutes,
  useValidateBulkOrders,
} from "utils/apis/lookups.api";
import {
  useAssignB2BRoute,
  useCancelB2BOrder,
  useGetB2BOrders,
  useCreateB2BBulkOrders,
  useAssignBagSeals,
  useValidateBulkBagsAssignment,
} from "utils/apis/b2b.api";
import { formatDate } from "date-fns";
import { Permissions } from "utils/enums";
import { saveFilters } from "utils/actions/user";
import DownloadTemplate from "./download-template";
import { LookUpContext } from "utils/reducers/lookup";
import { ExcelExport } from "@progress/kendo-react-excel-export";

const pageSize = 25;
const initialDataState = {
  sort: [
    {
      field: "code",
      dir: "asc",
    },
  ],
};

export default function B2BServices() {
  const user = useContext(UserContext);
  const { allBagTypes, coinContainers, currencies } = useContext(LookUpContext);

  const [dataState, setDataState] = useState<any>(initialDataState);
  const [selectedState, setSelectedState] = useState<any>({});
  const DATA_ITEM_KEY = "dataKey";
  const SELECTED_FIELD = "selected";
  const idGetter = getter(DATA_ITEM_KEY);

  const [ddlInRouteTeams, setDdlInRouteTeams] = useState("");
  const [selectedRequests, setSelectedRequests] = useState([]);
  const [btnAssignRouteDis, setBtnAssignRouteDis] = useState(true);
  const [btnAssignRouteTxt, setBtnAssignRouteTxt] = useState("Assign Route");
  const [btnCancelDis, setBtnCancelDis] = useState(true);
  const [btnCancelTxt, setBtnCancelTxt] = useState("Cancel");
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState<any>(
    user?.filters?.["b2b-services"] || {},
  );

  const [openSealFileUpload, setOpenSealFileUpload] = useState(false);
  const [sealAssignType, setSealAssignType] = useState("");
  const [bagSealData, setBagSealData] = useState<any[]>([]);
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  // Bulk upload states
  const [openFileUpload, setOpenFileUpload] = useState(false);
  const [routesTeams, setRoutesTeams] = useState<any[]>([]);

  let excelExport1: ExcelExport | null;
  let excelExport2: ExcelExport | null;

  const {
    mutate: validateB2BBulkOrders,
    isPending: validateOrdersPending,
    isSuccess: validateOrdersSuccess,
    data: validateData,
    isError: validateOrdersError,
    reset: validateReset,
  } = useValidateBulkOrders();
  const {
    mutate: createBulkOrders,
    isPending: createBulkOrdersPending,
    isSuccess: bulkOrderSuccess,
    isError: bulkOrderError,
    data: bulkB2BResponseData,
  } = useCreateB2BBulkOrders();

  const { data: customers } = useGetCustomers();
  const { data: inRouteTeams } = useGetShiftRoutes({
    cashCenterId: user.CashCenterId,
    shift: "morning",
    operationDate: formatDate(
      filters?.operationDate?.id || new Date(),
      "yyyy-MM-dd'T'00:00:00.000'Z'",
    ),
  });

  const { data: sourceLocationsData } = useGetCustomerCITList(
    filters?.customer?.id,
  );
  const { data: onwardLocationsData } = useGetCustomerCITList(
    filters?.customer?.id,
  );

  const {
    mutate: cancelB2BOrder,
    isSuccess: cancelSuccess,
    isError: cancelError,
  } = useCancelB2BOrder();

  const {
    mutate: assignB2BRoute,
    isSuccess: successB2BRoute,
    isError: errorB2BRoute,
  } = useAssignB2BRoute();

  const {
    mutate: validateBulkBagsAssignment,
    isPending: validateBulkBagsAssignmentPending,
    isSuccess: validateBulkBagsAssignmentSuccess,
    isError: validateBulkBagsAssignmentError,
    reset: validateBagReset,
  } = useValidateBulkBagsAssignment();

  const {
    mutate: assignBagSeals,
    isPending: assignBagSealsPending,
    isSuccess: assignBagSealsSuccess,
    isError: assignBagSealsError,
    data: assignBagData,
  } = useAssignBagSeals();

  const {
    isSuccess: requestSuccess,
    data: requestsData,
    isPending: loadingRequests,
  } = useGetB2BOrders({
    pageNumber: currentPage || 1,
    pageRowCount: pageSize,
    searchCriteria:
      filters?.searchCriteria?.id.length >= 3
        ? filters?.searchCriteria?.id
        : "",
    operationDate: formatDate(
      filters?.operationDate?.id || new Date(),
      "yyyy-MM-dd'T'00:00:00.000'Z'",
    ),
    cashCenterId: user.CashCenterId,
    customerId: filters?.customer?.id || "",
    sourceSPId: filters?.sourceLocation?.id || "",
    onwardSPId: filters?.onwardLocation?.id || "",
    pendingReason: filters?.pendingReason?.id || "",
  });

  const handleClearFilter = (key: string) => {
    const updatedFilter = { ...filters };
    delete updatedFilter[key];
    setFilters({ ...updatedFilter });
    saveFilters(user.dispatch, {
      ...user.filters,
      "b2b-services": updatedFilter,
    });
  };

  const onPageChange = (e: any) => {
    const _currentPage = e.page.skip / e.page.take + 1;
    setCurrentPage(_currentPage);
  };

  const onSelectionChange = (event: any) => {
    const newSelectedState = getSelectedState({
      event,
      selectedState,
      dataItemKey: DATA_ITEM_KEY,
    });
    setSelectedState(newSelectedState);
    const selections = Object.keys(newSelectedState).map((key) => ({
      itemKey: key,
      isSelected: newSelectedState[key],
    }));
    const selectedJobs = selections.filter((req) => req.isSelected === true);
    const requestIds: any = selectedJobs.map((req) => ({
      itemKey: req.itemKey,
    }));
    setSelectedRequests(requestIds);
    if (requestIds.length > 0) {
      setBtnCancelDis(false);
      if (ddlInRouteTeams) setBtnAssignRouteDis(false);
      else setBtnAssignRouteDis(true);
    } else {
      setBtnAssignRouteDis(true);
      setBtnCancelDis(true);
    }
  };

  const onHeaderSelectionChange = (event: any) => {
    const checkboxElement = event.syntheticEvent.target;
    const checked = checkboxElement.checked;
    const newSelectedState: any = {};
    event.dataItems.forEach((item: any) => {
      newSelectedState[idGetter(item)] = checked;
    });
    setSelectedState(newSelectedState);
    const selections = Object.keys(newSelectedState).map((key) => ({
      itemKey: key,
      isSelected: newSelectedState[key],
    }));
    const selectedRequests = selections.filter(
      (req) => req.isSelected === true,
    );
    const requestIds: any = selectedRequests.map((req) => ({
      itemKey: req.itemKey,
    }));
    setSelectedRequests(requestIds);
    if (requestIds.length > 0) {
      setBtnCancelDis(false);
      if (ddlInRouteTeams) setBtnAssignRouteDis(false);
      else setBtnAssignRouteDis(true);
    } else {
      setBtnAssignRouteDis(true);
      setBtnCancelDis(true);
    }
  };

  const onDataStateChange = (e: any) => {
    setDataState(e.dataState);
  };

  const onOperationDateChanged = (value?: Date) => {
    if (value) {
      setFilters({
        ...filters,
        operationDate: { name: formatDate(value, "PPP"), id: value },
      });
      saveFilters(user.dispatch, {
        ...user.filters,
        "b2b-services": {
          ...filters,
          operationDate: { name: formatDate(value, "PPP"), id: value },
        },
      });
    }
    setCurrentPage(1);
  };

  function ShowDetailsButtonCell(props: any) {
    const { requestId, jobNo } = props.dataItem;
    return (
      <td
        className="text-center"
        {...props}
        onClick={(e: Event) => {
          e.stopPropagation();
          props.selectionChange(props.dataItem);
        }}
      >
        {isOperationAllowed(Permissions.B2B, Permissions.View) ? (
          <Link to="/b2b-services-detail" state={{ requestId, jobNo }}>
            {jobNo}
          </Link>
        ) : (
          jobNo
        )}
      </td>
    );
  }

  const onFilterSearch = (e: any) => {
    setCurrentPage(1);
    setFilters({
      ...filters,
      searchCriteria: { name: e.target.value, id: e.target.value },
    });
    saveFilters(user.dispatch, {
      ...user.filters,
      "b2b-services": {
        ...filters,
        searchCriteria: { name: e.target.value, id: e.target.value },
      },
    });
  };

  const onDdlInRouteTeamsChanged = (value: string) => {
    if (!value) {
      setDdlInRouteTeams("");
      return;
    }
    setDdlInRouteTeams(value);
    if (selectedRequests.length > 0) setBtnAssignRouteDis(false);
    else setBtnAssignRouteDis(true);
  };

  const onBtnAssignRouteClicked = () => {
    if (selectedRequests.length === 0) {
      showToast("error", "No job selected to assign route.");
      return;
    }
    if (!ddlInRouteTeams) {
      showToast("error", "Please select route to assign.");
      return;
    }

    const cashCenterId = filters?.cashCenter?.id || user.CashCenterId;
    const routeNo = ddlInRouteTeams;
    const requestsIds = selectedRequests.map((sr: any) => ({
      requestId: sr.itemKey.split("_")[0],
      jobNo: sr.itemKey.split("_")[1],
    }));
    const assignmentDto: any = {
      cashCenterId,
      operationDate: formatDate(
        filters?.operationDate?.id || new Date(),
        "yyyy-MM-dd'T'00:00:00.000'Z'",
      ),
      routeNo,
      shift: "morning",
      requests: requestsIds,
    };
    setBtnAssignRouteDis(true);
    setBtnAssignRouteTxt("Assigning...");
    assignB2BRoute(assignmentDto);
  };

  const onBtnCancelClicked = () => {
    if (selectedRequests.length === 0) {
      showToast("error", "No job selected to assign route.");
      return;
    }
    setBtnCancelDis(true);
    setBtnCancelTxt("Canceling...");
    const requestsIds = selectedRequests.map((sr: any) => ({
      requestId: sr.itemKey.split("_")[0],
      jobNo: sr.itemKey.split("_")[1],
    }));
    cancelB2BOrder(requestsIds);
  };

  const handleFiltersUpdate = (key: string, val: any) => {
    const { sourceLocation, onwardLocation, ...remainingFilters } = filters;

    setFilters({
      ...(key === "customer" ? remainingFilters : filters),
      [key]: JSON.parse(val),
    });

    saveFilters(user.dispatch, {
      ...user.filters,
      "b2b-services": {
        ...(key === "customer" ? remainingFilters : filters),
        [key]: JSON.parse(val),
      },
    });
  };

  const onAssignSealModal = (type: string) => {
    setOpenSealFileUpload(true);
    setSealAssignType(type);
  };

  const handleBillingCustomer = (val: string) => {
    setCurrentPage(1);
    handleFiltersUpdate("customer", val);
  };

  const handleSourceLocation = (val: string) => {
    setCurrentPage(1);
    handleFiltersUpdate("sourceLocation", val);
  };

  const handleDestinationLocation = (val: string) => {
    setCurrentPage(1);
    handleFiltersUpdate("onwardLocation", val);
  };

  const onSealFileUpload = async (event: any) => {
    const payload = await onSealFileUploadPayload(
      event,
      sealAssignType,
      allBagTypes,
      coinContainers,
      currencies,
    );
    setBagSealData(payload);
    validateBulkBagsAssignment(payload);
  };
  const onConfirmBagSeals = () => {
    assignBagSeals(bagSealData);
  };

  // ----------------------------
  // Bulk file handler (Excel)
  // Expected columns: RequestNo, sourceBarcode, OnwardBarcode, ServiceDate,
  // InvoicingModel, Priority, JobNature, RouteNo
  // ----------------------------
  const fileHandler = (event: any) => {
    const fileObj = event.target.files[0] as File | null;
    if (!fileObj) return;

    if (
      ![
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "text/csv",
      ].includes(fileObj.type)
    ) {
      showToast("error", "File format not supported.");
      return;
    }

    ExcelRenderer(fileObj, (err: any, resp: any) => {
      if (err) {
        showToast("error", err);
      } else {
        const rows = resp.rows;
        const parsed: any[] = [];

        for (let i = 1; i < rows.length; i++) {
          const requestNo = rows[i][0];
          const sourceBarcode = rows[i][1];
          const onwardBarcode = rows[i][2];
          const serviceDate = rows[i][3];
          const invoicingModel = rows[i][4];
          const jobNature = rows[i][5];
          const jobType = rows[i][6];
          const priority = rows[i][7];
          const routeNo = rows[i][8];
          const requestedBy = rows[i][9];

          if (!sourceBarcode) continue;

          // Build payload with expected keys (exact casing as requested)
          parsed.push({
            requestNo: requestNo || 1,
            sourceBarcode: sourceBarcode ? String(sourceBarcode).trim() : "",
            onwardBarcode: onwardBarcode ? String(onwardBarcode).trim() : "",
            serviceDate: readOnlyExcelDate(serviceDate),
            invoicingModel: invoicingModel ? String(invoicingModel).trim() : "",
            jobType: jobType ? String(jobType).trim() : "",
            priority: priority ? String(priority).trim() : "",
            jobNature: jobNature ? String(jobNature).trim() : "",
            routeNo: routeNo ? String(routeNo).trim() : "",
            shift: "morning",
            requestedBy: requestedBy ? String(requestedBy).trim() : "",
          });
        }

        if (parsed.length > 0) {
          setRoutesTeams(parsed);
          validateB2BBulkOrders(parsed);
        } else {
          showToast("error", "No data found in excel file.");
        }
      }
    });
  };

  const onConfirmFileOrders = () => {
    if (routesTeams.length === 0) {
      showToast("error", "No orders to add. Please upload a file first.");
      return;
    }
    createBulkOrders(routesTeams);
  };

  // function actions(props: any) {
  //   const {
  //     jobNo,
  //     requestId,
  //     // consignmentsAssigned,
  //     consignmentsCollected,
  //   } = props?.dataItem || {};
  //   return (
  //     <td>
  //       <div className="flex gap-2">
  //         {!consignmentsCollected ? (
  //           <Link
  //             to={`/b2b-services-view-order?jobNo=${jobNo}&requestId=${requestId}`}
  //             className="!no-underline"
  //           >
  //             <Button
  //               variant="secondary"
  //               size="sm"
  //               className="flex gap-2 text-xs no-underline"
  //             >
  //               <BsFillEyeFill />
  //               Assign
  //             </Button>
  //           </Link>
  //         ) : (
  //           ""
  //         )}
  //         {/* {!consignmentsAssigned &&
  //           status !== "Pending" &&
  //           jobType !== "Collection" && (
  //             <Button variant="secondary" size="sm" asChild>
  //               <Link
  //                 to={`/assign-order?jobNo=${jobNo}&requestId=${requestId}`}
  //                 className="flex gap-2 text-white"
  //               >
  //                 <MdAssignmentInd /> Assign
  //               </Link>
  //             </Button>
  //           )} */}
  //       </div>
  //     </td>
  //   );
  // }

  useEffect(() => {
    if (requestSuccess && requestsData?.data) {
      setTotalRecords(requestsData?.totalRecords);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestSuccess, requestsData?.data]);

  useEffect(() => {
    if (validateOrdersError || validateData) {
      setOpenFileUpload(false);
      setRoutesTeams([]);
      validateReset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validateOrdersError, validateData]);

  // Reset dialog & routes on bulk create result
  useEffect(() => {
    if (bulkOrderSuccess) {
      setOpenFileUpload(false);
      setRoutesTeams([]);
      validateReset();
    }
    if (bulkOrderError) {
      setOpenFileUpload(false);
      setRoutesTeams([]);
      validateReset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bulkOrderSuccess, bulkOrderError]);

  useEffect(() => {
    if (cancelSuccess) {
      setBtnCancelDis(true);
      setBtnCancelTxt("Cancel");
      setSelectedState({});
    }
    if (cancelError) {
      setBtnCancelDis(false);
      setBtnCancelTxt("Cancel");
    }
  }, [cancelError, cancelSuccess]);

  useEffect(() => {
    if (successB2BRoute) {
      setDdlInRouteTeams("");
      setBtnAssignRouteTxt("Assign Route");
      setSelectedState({});
    }
    if (errorB2BRoute) {
      setBtnAssignRouteDis(false);
      setBtnAssignRouteTxt("Assign Route");
    }
  }, [errorB2BRoute, successB2BRoute]);

  useEffect(() => {
    if (validateBulkBagsAssignmentError) {
      setOpenSealFileUpload(false);
      if (fileInputRef.current) fileInputRef.current.value = "";
      setBagSealData([]);
      validateBagReset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validateBulkBagsAssignmentError]);

  useEffect(() => {
    if (assignBagSealsSuccess) {
      setOpenSealFileUpload(false);
      setBagSealData([]);
    }

    if (assignBagSealsError) {
      if (fileInputRef.current) fileInputRef.current.value = "";
      setBagSealData([]);
    }
  }, [assignBagSealsSuccess, assignBagSealsError]);

  useEffect(() => {
    if (assignBagData?.consignments?.length) {
      excelExport1?.save(assignBagData?.consignments);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assignBagData]);

  useEffect(() => {
    if (bulkB2BResponseData?.length) {
      excelExport2?.save(bulkB2BResponseData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bulkB2BResponseData]);

  return (
    <Layout>
      <Breadcrumb className="mt-5 mx-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <Link to="/dashboard">Home</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>B2B </BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>

      <Card className="mt-3 mx-4">
        <CardContent>
          <CardDescription className="pt-6">
            <div className="flex mb-3 gap-3">
              <Popover>
                <PopoverTrigger asChild>
                  <Button
                    variant="secondary"
                    className="p-2"
                    title="Apply Filters"
                  >
                    <SlidersHorizontal className="" />
                  </Button>
                </PopoverTrigger>
                <PopoverContent align="start" className="w-[600px]">
                  <h6 className="font-semibold text-lg">Apply Filters</h6>
                  <div className="grid grid-cols-2 gap-4 mt-3">
                    <Combobox
                      placeholder="Select Customer"
                      value={JSON.stringify(filters?.customer) || ""}
                      data={customers?.map((item) => ({
                        value: JSON.stringify({
                          name: item.name,
                          id: item.customerId,
                        }),
                        label: item.name,
                      }))}
                      setValue={handleBillingCustomer}
                    />

                    <Combobox
                      placeholder="Select Source Location"
                      value={JSON.stringify(filters?.sourceLocation) || ""}
                      data={sourceLocationsData?.map((item: any) => ({
                        value: JSON.stringify({
                          name: `${item.barcode}-${item.locationId}`,
                          id: item.servicePointId,
                        }),
                        label: `${item.barcode}-${item.locationId}`,
                      }))}
                      setValue={handleSourceLocation}
                    />

                    <Combobox
                      placeholder="Select Destination Location"
                      value={JSON.stringify(filters?.onwardLocation) || ""}
                      data={onwardLocationsData?.map((item: any) => ({
                        value: JSON.stringify({
                          name: `${item.barcode}-${item.locationId}`,
                          id: item.servicePointId,
                        }),
                        label: `${item.barcode}-${item.locationId}`,
                      }))}
                      setValue={handleDestinationLocation}
                    />
                  </div>
                </PopoverContent>
              </Popover>

              <div className="w-[15%]">
                <DatePicker
                  placeholder="Select Operation Date"
                  selectedDate={filters?.operationDate?.id || new Date()}
                  onSelectDate={onOperationDateChanged}
                />
              </div>

              {isOperationAllowed(Permissions.B2B, Permissions.Edit) ? (
                <div className="w-[15%]">
                  <Combobox
                    setValue={onDdlInRouteTeamsChanged}
                    value={ddlInRouteTeams}
                    placeholder="Select Route"
                    data={inRouteTeams?.map((item: any) => ({
                      value: item?.routeNo,
                      label: `${item.routeNo} (${item.description})`,
                    }))}
                  />
                </div>
              ) : null}

              <div className="flex-1 flex justify-end gap-2">
                {isOperationAllowed(Permissions.B2B, Permissions.Add) ? (
                  <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                      <Button variant="secondary" className="gap-2">
                        <CirclePlus /> Create Request
                      </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent className="w-[180px]">
                      <DropdownMenuItem>
                        <Link
                          to="/create-b2b-service"
                          state={{ createType: "single" }}
                        >
                          Single Request
                        </Link>
                      </DropdownMenuItem>
                      <DropdownMenuItem
                        onClick={() => {
                          setOpenFileUpload(true);
                        }}
                        className="cursor-pointer"
                      >
                        Bulk Requests
                      </DropdownMenuItem>
                    </DropdownMenuContent>
                  </DropdownMenu>
                ) : null}

                {isOperationAllowed(Permissions.B2B, Permissions.Edit) ? (
                  <Button
                    variant="secondary"
                    disabled={btnAssignRouteDis}
                    onClick={onBtnAssignRouteClicked}
                  >
                    {btnAssignRouteTxt}
                  </Button>
                ) : null}
                {isOperationAllowed(Permissions.B2B, Permissions.Edit) && (
                  <DownloadTemplate
                    operationDate={filters?.operationDate?.id}
                  />
                )}
                {isOperationAllowed(Permissions.B2B, Permissions.Edit) && (
                  <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                      <Button variant="secondary" className="gap-2">
                        <LucideFileDigit /> Bulk Bags Assignment
                      </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent align="start" className="w-[180px]">
                      <DropdownMenuItem
                        onClick={() => {
                          onAssignSealModal("Single Currency");
                        }}
                        className="cursor-pointer"
                      >
                        Single Currency
                      </DropdownMenuItem>
                      <DropdownMenuItem
                        onClick={() => {
                          onAssignSealModal("AED Coins");
                        }}
                        className="cursor-pointer"
                      >
                        AED Coins
                      </DropdownMenuItem>
                      <DropdownMenuItem
                        onClick={() => {
                          onAssignSealModal("Foreign Currency");
                        }}
                        className="cursor-pointer"
                      >
                        Foreign Currency
                      </DropdownMenuItem>
                    </DropdownMenuContent>
                  </DropdownMenu>
                )}
                <Button
                  variant="secondary"
                  disabled={btnCancelDis}
                  onClick={onBtnCancelClicked}
                >
                  {btnCancelTxt}
                </Button>
              </div>
            </div>

            <div className="flex gap-2 flex-wrap mb-3 items-center">
              {Object.entries(filters).map(([key, val]: any, i) =>
                val.id ? (
                  <Badge
                    variant="secondary"
                    className="gap-3 pr-1 cursor-pointer"
                    key={i}
                  >
                    {val?.name}{" "}
                    <CircleX
                      onClick={() => {
                        handleClearFilter(key);
                      }}
                    />
                  </Badge>
                ) : null,
              )}
            </div>

            <div className="border-b mt-5 mb-2 bg-accent" />
            {isOperationAllowed(Permissions.B2B, Permissions.Search) ? (
              <Input
                className="w-full max-w-[420px] mb-2 ml-auto"
                value={filters.searchCriteria?.id}
                onChange={onFilterSearch}
                title="Search: Job No., Job Nature, Status, Route No., Shift"
                placeholder="Search: Job No., Job Nature, Status, Route No., Shift"
              />
            ) : null}
            {loadingRequests ? (
              <div className="k-loading-mask">
                <span className="k-loading-text">Loading</span>
                <div className="k-loading-image" />
                <div className="k-loading-color" />
              </div>
            ) : (
              <Grid
                className="text-xs"
                dataItemKey={DATA_ITEM_KEY}
                selectedField={SELECTED_FIELD}
                selectable={{
                  enabled: true,
                  drag: true,
                  cell: false,
                  mode: "multiple",
                }}
                data={process(
                  requestsData?.data?.map((req: any) => ({
                    ...req,
                    dataKey: `${req.requestId}_${req.jobNo}`,
                    [SELECTED_FIELD]:
                      selectedState[
                        idGetter({
                          ...req,
                          dataKey: `${req.requestId}_${req.jobNo}`,
                        })
                      ],
                  })) || [],
                  { ...dataState, skip: 0 },
                )}
                {...dataState}
                pageable
                onPageChange={onPageChange}
                pageSize={pageSize}
                total={totalRecords}
                skip={(currentPage - 1) * pageSize}
                take={pageSize}
                onDataStateChange={onDataStateChange}
                sortable
                filterable
                onSelectionChange={onSelectionChange}
                onHeaderSelectionChange={onHeaderSelectionChange}
                size="small"
              >
                <Column
                  field={SELECTED_FIELD}
                  filterable={false}
                  width="40px"
                  headerSelectionValue={
                    requestsData?.data?.findIndex(
                      (item: any) =>
                        !selectedState[
                          idGetter({
                            ...item,
                            dataKey: `${item.requestId}_${item.jobNo}`,
                          })
                        ],
                    ) === -1
                  }
                />
                <Column field="orderId" title="Order Id" width={160} />
                <Column
                  title="Job #"
                  width={80}
                  field="jobNo"
                  cell={ShowDetailsButtonCell}
                />
                <Column field="customer" title="Customer" />
                <Column
                  field="sourceBarcode"
                  title="Source"
                  cell={({ dataItem }) => (
                    <td>{`${dataItem?.sourceBarcode}-${dataItem?.sourceLocationId}`}</td>
                  )}
                />
                <Column
                  field="onwardBarcode"
                  title="Onward"
                  cell={({ dataItem }) => (
                    <td>{`${dataItem?.onwardBarcode}-${dataItem?.onwardLocationId}`}</td>
                  )}
                />
                <Column
                  field="routeNo"
                  title="Route"
                  width={120}
                  className="text-center"
                />

                <Column
                  field="jobType"
                  title="Job Type"
                  width={90}
                  className="text-center"
                />
                <Column
                  width="105"
                  field="jobNature"
                  title="Job Nature"
                  className="text-center"
                />
                <Column
                  field="status"
                  title="Job Status"
                  className="text-center"
                  width={180}
                />
                <Column field="requestedBy" title="Requested By" />
                <Column field="remarks" title="Remarks" />
                {/* <Column cell={actions} title="Actions" width="120px" /> */}
              </Grid>
            )}
            <ExcelExport
              ref={(exporter) => {
                excelExport1 = exporter;
              }}
              fileName={`B2B_Bags_Assignment_${new Date().toDateString()}.xlsx`}
              columns={[
                { field: "serviceDate", title: "Service Date" },
                { field: "routeNo", title: "Route No" },
                { field: "sourceBarcode", title: "Source Barcode" },
                { field: "onwardBarcode", title: "Onward Barcode" },
                { field: "sealNo", title: "Seal No" },
                { field: "containerType", title: "Bag Type" },
                { field: "currency", title: "Currency" },
                { field: "declaredValue", title: "Value" },
                { field: "denominations", title: "Coins Denomination" },
                { field: "denomination", title: "Note Denomination" },
                { field: "count", title: "Count" },
                { field: "assigmentStatus", title: "Status" },
                { field: "locationId", title: "Location ID" },
              ]}
            />
            <ExcelExport
              ref={(exporter) => {
                excelExport2 = exporter;
              }}
              fileName={`B2B_Bulk_Orders_${new Date().toLocaleString()}.xlsx`}
              columns={[
                { field: "sourceBarcode", title: "Source Barcode" },
                { field: "onwardBarcode", title: "Onward Barcode" },
                { field: "serviceDate", title: "Service Date" },
                { field: "invoicingModel", title: "Invoicing Model" },
                { field: "jobType", title: "Job Type" },
                { field: "jobNature", title: "Job Nature" },
                { field: "routeNo", title: "Route No" },
                { field: "requestedBy", title: "Requested By" },
                { field: "status", title: "Status" },
                { field: "message", title: "Message" },
              ]}
            />
          </CardDescription>
        </CardContent>
      </Card>

      {/* Bulk Upload Dialog */}
      <Dialog
        open={openFileUpload}
        onOpenChange={(val) => {
          setRoutesTeams([]);
          setOpenFileUpload(val);
        }}
      >
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Upload B2B Orders</DialogTitle>
          </DialogHeader>
          <DialogDescription className="pt-6">
            {routesTeams.length > 0 ? (
              <div className="flex flex-col items-center justify-center py-5">
                <p className="mb-5 text-gray-500 dark:text-gray-400">
                  File uploaded successfully! Now add orders.
                </p>
                <Button
                  variant="secondary"
                  onClick={onConfirmFileOrders}
                  isLoading={validateOrdersPending || createBulkOrdersPending}
                  disabled={!validateOrdersSuccess}
                >
                  Add Orders
                </Button>
              </div>
            ) : (
              <label
                htmlFor="dropzone-file"
                className="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
              >
                <span className="sr-only">Upload B2B Orders File</span>
                <div className="flex flex-col items-center justify-center pt-5 pb-6">
                  <svg
                    className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 20 16"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                    />
                  </svg>
                  <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                    <span className="font-semibold">Click to upload</span> or
                    drag and drop
                  </p>
                  <p className="text-xs text-gray-500 dark:text-gray-400">
                    XLS, XLSX, CSV (MAX. 5GB)
                  </p>
                </div>
                <input
                  id="dropzone-file"
                  accept=".xlsx, .xls, .csv"
                  type="file"
                  className="hidden"
                  onChange={fileHandler}
                />
              </label>
            )}
          </DialogDescription>
        </DialogContent>
      </Dialog>

      {/* Assign Seal Orders */}

      <Dialog
        open={openSealFileUpload}
        onOpenChange={() => {
          setBagSealData([]);
          setOpenSealFileUpload(false);
        }}
      >
        <DialogContent>
          <DialogHeader>
            <DialogTitle>{sealAssignType} Bags Assignment</DialogTitle>
          </DialogHeader>
          <DialogDescription className="pt-6">
            {bagSealData.length ? (
              <div className="flex flex-col items-center justify-center py-5">
                <p className="mb-2 text-gray-500 dark:text-gray-400">
                  File parsed successfully!{" "}
                  <strong>{bagSealData.length}</strong> rows ready.
                </p>
                <div className="flex gap-2">
                  <Button
                    variant="secondary"
                    onClick={onConfirmBagSeals}
                    isLoading={
                      assignBagSealsPending || validateBulkBagsAssignmentPending
                    }
                    disabled={!validateBulkBagsAssignmentSuccess}
                  >
                    Assign Seals
                  </Button>
                  <Button
                    variant="ghost"
                    onClick={() => {
                      if (fileInputRef.current) fileInputRef.current.value = "";
                      setBagSealData([]);
                    }}
                  >
                    Choose another file
                  </Button>
                </div>
              </div>
            ) : (
              <label
                htmlFor="dropzone-file"
                className="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
              >
                <span className="sr-only">Upload file</span>
                <div className="flex flex-col items-center justify-center pt-5 pb-6">
                  <svg
                    className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 20 16"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                    />
                  </svg>
                  <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                    <span className="font-semibold">Click to upload</span> or
                    drag and drop
                  </p>
                  <p className="text-xs text-gray-500 dark:text-gray-400">
                    XLS, XLSX, CSV (MAX. 5GB)
                  </p>
                </div>
                <input
                  ref={fileInputRef}
                  id="dropzone-file"
                  accept=".xlsx, .xls, .csv"
                  type="file"
                  className="hidden"
                  // eslint-disable-next-line @typescript-eslint/no-misused-promises
                  onChange={onSealFileUpload}
                />
              </label>
            )}
          </DialogDescription>
        </DialogContent>
      </Dialog>
    </Layout>
  );
}
